import { Updater } from "./common";
var dummyCert;
function WhenHaveCert(fn) {
    if (!dummyCert) {
        RTCPeerConnection.generateCertificate({
            name: 'RSASSA-PKCS1-v1_5',
            hash: 'SHA-256',
            modulusLength: 2048,
            publicExponent: new Uint8Array([1, 0, 1])
        }).then((cert) => {
            dummyCert = cert;
            fn();
        });
    }
    else {
        fn();
    }
}
export function GetSDPCreds(sdp) {
    let ufragM = (/\na=ice-ufrag:([^\s]+)/g).exec(sdp);
    let pwdM = (/\na=ice-pwd:([^\s]+)/g).exec(sdp);
    if (!ufragM || !ufragM[1] || !pwdM || !pwdM[1]) {
        throw "Can't parse SDP creds from '" + sdp + "'";
    }
    return {
        ufrag: ufragM[1],
        pwd: pwdM[1],
    };
}
export function ReplaceSDPCreds(sdp, ufrag, pwd) {
    return sdp.replace(/\na=candidate:[^\n]*/g, "")
        .replace(/\na=ice-ufrag:[^\n]*/g, "\na=ice-ufrag:" + ufrag)
        .replace(/\na=ice-pwd:[^\n]*/g, "\na=ice-pwd:" + pwd);
}
export class IceAgent {
    constructor() {
        this.iceServers = [{ urls: "stun:stun.l.google.com:19302" }];
    }
    setIceServers(iceServers) {
        this.iceServers = iceServers;
    }
    createConnection() {
        this.peerConn = new RTCPeerConnection({ certificates: [dummyCert], iceServers: this.iceServers });
        this.peerConn.createDataChannel("data");
    }
    cleanupSdp(sdp, ufrag, pwd) {
        return sdp.replace(/\na=candidate:[^\n]*/g, "")
            .replace(/\na=ice-ufrag:[^\n]*/g, "\na=ice-ufrag:" + ufrag)
            .replace(/\na=ice-pwd:[^\n]*/g, "\na=ice-pwd:" + pwd);
    }
    close() {
        this.peerConn.close();
    }
    dummyClient(ufrag, callback, configuration) {
        return new Promise((resolve, reject) => {
            WhenHaveCert(() => {
                this.createConnection();
                var rej = (reason) => { reject(reason); };
                this.peerConn.onicecandidate = (ev) => {
                    if (ev.candidate == null) {
                        resolve(this.peerConn.localDescription);
                    }
                    callback.bind(this)(ev);
                };
                this.peerConn.createOffer().then((offer) => {
                    this.peerConn.setLocalDescription(offer)
                        .then(() => {
                        if (!configuration) {
                            configuration = { iceServers: [] };
                        }
                        var connHelper = new RTCPeerConnection(configuration);
                        connHelper.setRemoteDescription(offer);
                        connHelper.createAnswer()
                            .then((answer) => {
                            if (answer.sdp == undefined) {
                                throw "Unexpected empty SDP";
                            }
                            let sdp = this.cleanupSdp(answer.sdp, ufrag, "PortDependentForwarding0");
                            connHelper.close();
                            this.peerConn.setRemoteDescription({ type: "answer", sdp: sdp })
                                .catch(rej);
                        }).catch(rej);
                    }).catch(rej);
                }).catch(rej);
            });
        });
    }
}
export var ConnectivityType;
(function (ConnectivityType) {
    ConnectivityType["None"] = "no_connectivity";
    ConnectivityType["NotFound"] = "not_found";
    ConnectivityType["Mapped"] = "mapped";
    ConnectivityType["NotMapped"] = "not_mapped";
    ConnectivityType["NoCandidates"] = "no_candidates";
})(ConnectivityType || (ConnectivityType = {}));
export function CandidateType(cand) {
    if (!cand) {
        return EndpointStyle.Unknown;
    }
    let line = cand.candidate;
    // candidate: "candidate:3717574005 1 udp 1686052607 10.22.0.2 43542 typ srflx raddr 172.18.0.1 rport 43542 generation 0 ufrag cnRm network-id 1 network-cost 50"
    let portIdx = line.indexOf(" rport ");
    if (portIdx == -1) {
        return EndpointStyle.Unknown;
    }
    portIdx += 7;
    let localPort = line.substr(portIdx).split(' ')[0];
    let udpIdx = line.indexOf(" udp ");
    if (udpIdx == -1) {
        return EndpointStyle.Unknown;
    }
    udpIdx += 5;
    let remotePort = line.substr(udpIdx).split(' ')[2];
    if (!localPort || !remotePort) {
        return EndpointStyle.Unknown;
    }
    if (localPort == remotePort) {
        return EndpointStyle.Strong;
    }
    return EndpointStyle.Weak;
}
export var EndpointStyle;
(function (EndpointStyle) {
    EndpointStyle["Strong"] = "strong";
    EndpointStyle["Weak"] = "weak";
    EndpointStyle["Strange"] = "strange";
    EndpointStyle["Unknown"] = "unk";
})(EndpointStyle || (EndpointStyle = {}));
export function ConnectivityToEndpoint(connInfo) {
    if (!connInfo) {
        return EndpointStyle.Unknown;
    }
    if (!connInfo.randomPorts) {
        return EndpointStyle.Strong;
    }
    if (connInfo.type == ConnectivityType.Mapped) {
        return EndpointStyle.Strange;
    }
    return EndpointStyle.Weak;
}
export function SdpToIceCreds(sdp) {
    let ufs = [];
    let pwds = [];
    let ufragre = /\na=ice-ufrag:([^\r\n]*)/g;
    let pwdre = /\na=ice-pwd:([^\r\n]*)/g;
    while (true) {
        let m = ufragre.exec(sdp);
        if (m) {
            ufs.push(m[1]);
        }
        else {
            break;
        }
    }
    while (true) {
        let m = pwdre.exec(sdp);
        if (m) {
            pwds.push(m[1]);
        }
        else {
            break;
        }
    }
    if (ufs.length != pwds.length) {
        return [];
    }
    let ret = [];
    for (let i = 0; i < ufs.length; ++i) {
        ret.push({ ufrag: ufs[i], pwd: pwds[i] });
    }
    return ret;
}
export var CheckerState;
(function (CheckerState) {
    CheckerState[CheckerState["Started"] = 0] = "Started";
    CheckerState[CheckerState["GatheringCandidates"] = 1] = "GatheringCandidates";
    CheckerState[CheckerState["ReceivingOffer"] = 2] = "ReceivingOffer";
    CheckerState[CheckerState["PollingForResult"] = 3] = "PollingForResult";
    CheckerState[CheckerState["Complete"] = 4] = "Complete";
})(CheckerState || (CheckerState = {}));
export class ConnectivityChecker {
    constructor(base_url) {
        this.max_retries = 3;
        this.random_ports = true;
        this.polling_period = 2000;
        this.not_mapped_retry_period = 200;
        this.base_url = base_url;
    }
    _onStateChange(ev) {
        if (this.onStateChange) {
            this.onStateChange(ev);
        }
    }
    check() {
        return new Promise((resolve, reject) => {
            let rej = (reason) => { reject(reason); };
            this._onStateChange(CheckerState.Started);
            let agent = new IceAgent();
            let collectedCands = [];
            let ufrag = RandomUfrag();
            let base_url = this.base_url;
            this._onStateChange(CheckerState.GatheringCandidates);
            agent.dummyClient(ufrag, (ev) => {
                console.log(ev.candidate);
                let c = ev.candidate;
                if (c != null) {
                    collectedCands.push({ candidate: c.candidate, sdpMid: c.sdpMid });
                }
                else {
                    this._onStateChange(CheckerState.ReceivingOffer);
                    // No more candidates
                    fetch({
                        method: "POST",
                        url: base_url + '/trickle',
                        body: JSON.stringify({ "ufrag": ufrag, "cands": collectedCands }),
                    }).then((resp) => {
                        resp.json().then((retJson) => {
                            let ufrag = "";
                            for (let i in retJson) {
                                agent.peerConn.addIceCandidate(retJson[i]);
                                ufrag = retJson[i].ufrag;
                                this.random_ports = retJson[i].rnd;
                            }
                            if (!ufrag) {
                                resolve({
                                    type: ConnectivityType.NoCandidates,
                                    endpoint: null,
                                    randomPorts: undefined,
                                    ufrag: '',
                                });
                                return;
                            }
                            let upd = new Updater(this.polling_period);
                            let retries = 0;
                            let retriedNotMapped = false;
                            let cachedResult = ConnectivityType.NotFound;
                            this._onStateChange(CheckerState.PollingForResult);
                            upd.start(() => {
                                fetch({
                                    method: "POST",
                                    url: base_url + "/result",
                                    body: JSON.stringify({ "ufrag": ufrag })
                                }).then((resp) => {
                                    resp.json().then((resultJson) => {
                                        let result = resultJson['result'];
                                        if (result && result != ConnectivityType.NotFound) {
                                            cachedResult = result;
                                        }
                                        if (retriedNotMapped && result != ConnectivityType.Mapped) {
                                            result = ConnectivityType.NotMapped;
                                        }
                                        if (retries < this.max_retries) {
                                            if (result == ConnectivityType.NotFound || result == ConnectivityType.None) {
                                                retries += 1;
                                                upd.scheduleAgain();
                                                return;
                                            }
                                        }
                                        if (result == ConnectivityType.NotMapped) {
                                            if (!retriedNotMapped) {
                                                retriedNotMapped = true;
                                                upd.scheduleAgain(this.not_mapped_retry_period);
                                                return;
                                            }
                                        }
                                        agent.close();
                                        resolve({ type: cachedResult, randomPorts: this.random_ports, endpoint: resultJson.ep, ufrag: ufrag });
                                        this._onStateChange(CheckerState.Complete);
                                    }).catch(rej);
                                }).catch(rej);
                            });
                        }).catch(rej);
                    }).catch(rej);
                    return;
                }
            });
        });
    }
}
export class RTCLifeCycle {
    constructor(pc) {
        this.collectedCandidates = [];
        this.tracks = [];
        this.pc = pc;
        pc.onicecandidate = (ev) => {
            if (ev.candidate != null) {
                this.collectedCandidates.push(ev.candidate);
            }
            if (this.onicecandidate) {
                this.onicecandidate(ev);
            }
        };
        pc.onicecandidateerror = (ev) => {
            console.log(ev.errorText + " " + ev.errorCode);
        };
        pc.ontrack = (ev) => {
            if (ev.track) {
                this.tracks.push(ev);
            }
        };
    }
    processTracks(handler) {
        this.tracks.forEach(el => {
            handler.bind(this.pc)(el);
        });
        this.pc.ontrack = handler;
    }
    makeOffer() {
        return this.pc.createOffer();
    }
    makeAnswer(offer) {
        return new Promise((resolve, reject) => {
            this.pc.setRemoteDescription(offer)
                .then(() => {
                this.pc.createAnswer()
                    .then((desc) => {
                    resolve(desc);
                })
                    .catch(reject);
            })
                .catch(reject);
        });
    }
}
const randomCset = "abcdefghijklmnopqrstuvwxyz1234567890ABCDEFGHIJKLMNOPQRSTUVWXYZ";
export function RandomUfrag() {
    let ufrag = "";
    for (let i = 0; i < 8; ++i) {
        ufrag += randomCset[Math.trunc(Math.random() * randomCset.length)];
    }
    return ufrag;
}
export function RandomPwd() {
    let pwd = "";
    for (let i = 0; i < 22; ++i) {
        pwd += randomCset[Math.trunc(Math.random() * randomCset.length)];
    }
    return pwd;
}
export class RTCFactory {
    constructor() {
        this.tracks = [];
        this.tranceivers = [];
    }
    provideDataStream() {
        this.hasData = true;
    }
    provideTranceiver(track, tc) {
        this.tranceivers.push({ track: track, tranceiver: tc });
    }
    provideTrack(track) {
        this.tracks.push(track);
    }
    provideConfiguration(config) {
        this.config = config;
    }
    provideNatatat(natatat) {
        this.natatat = natatat;
    }
    createLifecycle(init) {
        return new Promise((resolve, reject) => {
            WhenHaveCert(() => {
                if (!this.config) {
                    this.config = {};
                }
                this.config.certificates = [dummyCert];
                if (this.natatat) {
                    this.config.iceServers = [];
                    this.config.bundlePolicy = "max-bundle";
                    this.config.rtcpMuxPolicy = "require";
                }
                let pc = new RTCPeerConnection(this.config);
                let lc = new RTCLifeCycle(pc);
                if (this.hasData) {
                    lc.data = pc.createDataChannel("data");
                }
                for (let i = 0; i < this.tracks.length; ++i) {
                    pc.addTrack(this.tracks[i]);
                }
                for (let i = 0; i < this.tranceivers.length; ++i) {
                    let tc = this.tranceivers[i];
                    pc.addTransceiver(tc.track, tc.tranceiver);
                }
                if (init) {
                    init(lc);
                }
                resolve(lc);
            });
        });
    }
}
